export enum AccessMasterRolesEnum {
	NATIONAL_ADMIN = 'A51_NAT_ADM',
	NATIONAL_VALIDATOR = 'A51_NAT_VAL',
	NATIONAL_DGOS = 'A51_NAT_DGOS',
	LIQUIDATOR = 'A51_CPAM_LIQ',
	LIQUIDATOR_MANAGER = 'A51_CPAM_MNG_LIQ',
	CPAM_SUPERVISOR = 'A51_CPAM_SUPERVISOR',
	EVALUATION_TC = 'A51_EVAL_TC',
	EVALUATION_DM = 'A51_EVAL_DM',
	EXPATIENT_ADMIN = 'A51_NAT_EXPATIENT'
}

export enum BusinessRolesEnum {
	ADMIN_LOCAL = 'ROLE_ADMIN_LOCAL',
	ADMIN_LOCAL_CLOSED = 'ROLE_ADMIN_LOCAL_CLOSED',
	ADMINISTRATOR = 'ROLE_BILLING_FILE_USER',
	MOBILE_TEAM = 'ROLE_MOBILE_TEAM',
	PHARMACIST = 'ROLE_PHARMACIST',
	BILLING_ENTRY_USER = 'ROLE_BILLING_ENTRY_USER',
	EDS_USER = 'ROLE_EDS_USER',
	PROJECT_MANAGER = 'ROLE_PROJECT_MANAGER',
	PEPS_USER = 'ROLE_PEPS_USER',
	IPEP_USER = 'ROLE_IPEP_USER',
	FINANCIAL_CONTROLLER = 'ROLE_FINANCIAL_CONTROLLER',
	SUPERVISOR_IDEL = 'ROLE_SUPERVISOR_IDEL',
	SUPERVISOR_IDEL_CLOSED = 'ROLE_SUPERVISOR_IDEL_CLOSED',
	IDEL = 'ROLE_IDEL',
	VALIDATOR_IDEL = 'ROLE_VALIDATOR_IDEL',
	PEPS_USER_IMPORT = 'ROLE_PEPS_USER_IMPORT'
}

export enum TechnicalRolesEnum {
	PROJECT_LIST = 'ROLE_PROJECT_LIST',
	PROJECT_VIEW = 'ROLE_PROJECT_VIEW',
	IMPORTER_LIST = 'ROLE_IMPORTER_LIST',
	IMPORTER_VIEW = 'ROLE_IMPORTER_VIEW',
	IMPORTER_ADD = 'ROLE_IMPORTER_ADD',
	IMPORTER_DELETE = 'ROLE_IMPORTER_DELETE',
	IMPORTER_DOWNLOAD = 'ROLE_IMPORTER_DOWNLOAD',
	PATIENT_ADD = 'ROLE_PATIENT_ADD',
	PATIENT_DELETE = 'ROLE_PATIENT_DELETE',
	PATIENT_LIST = 'ROLE_PATIENT_LIST',
	PATIENT_PCR_ADD = 'ROLE_PATIENT_PCR_ADD',
	ADDRESSING_ADD = 'ROLE_PATIENT_PCR_EDIT',
	ADDRESSING_LIST = 'ROLE_PATIENT_PCR_LIST',
	ADDRESSING_DELETE = 'ROLE_PATIENT_PCR_DELETE',
	PATIENT_FILE = 'ROLE_PATIENT_FILE',
	ACTOR_LIST = 'ROLE_ACTOR_LIST',
	ACTOR_ADD = 'ROLE_ACTOR_ADD',
	ACTOR_EDIT = 'ROLE_ACTOR_EDIT',
	ACTOR_DELETE = 'ROLE_ACTOR_DELETE',
	SEARCH_NIR = 'ROLE_SEARCH_NIR',
	FILE_STORAGE_LIST = 'ROLE_FILE_STORAGE_LIST',
	FILE_STORAGE_DELETE = 'ROLE_FILE_STORAGE_DELETE',
	FILE_STORAGE_DOWNLOAD = 'ROLE_FILE_STORAGE_DOWNLOAD',
	FILE_STORAGE_ADD = 'ROLE_FILE_STORAGE_ADD',
	FILE_STORAGE_VIEW = 'ROLE_FILE_STORAGE_VIEW',
	CONTACT_LIST = 'ROLE_CONTACT_LIST',
	CONTACT_DELETE = 'ROLE_CONTACT_DELETE',
	CONTACT_DOWNLOAD = 'ROLE_CONTACT_DOWNLOAD',
	CONTACT_ADD = 'ROLE_CONTACT_ADD',
	CONTACT_VIEW = 'ROLE_CONTACT_VIEW',
	PAYMENT_LIST = 'ROLE_PAYMENT_LIST',
	EXPORT_LIST = 'ROLE_EXPORT_LIST',
	EXPORT_PAYMENT_LIST = 'ROLE_EXPORT_PAYMENT_LIST',
	EXPORT_PAYMENT_ADD = 'ROLE_EXPORT_PAYMENT_ADD',
	DATA_LINE_LIST = 'ROLE_DATA_LINE_LIST',
	DATA_LINE_ADD = 'ROLE_DATA_LINE_ADD',
	ACTOR_IMPORTER_LIST = 'ROLE_IMPORTER_ACTOR_LIST',
	ACTOR_IMPORTER_DELETE = 'ROLE_IMPORTER_ACTOR_DELETE',
	ACTOR_IMPORTER_DOWNLOAD = 'ROLE_IMPORTER_ACTOR_DOWNLOAD',
	ACTOR_IMPORTER_ADD = 'ROLE_IMPORTER_ACTOR_ADD',
	ACTOR_IMPORTER_VIEW = 'ROLE_IMPORTER_ACTOR_VIEW',
	USER_ACTOR_LIST = 'ROLE_USER_ACTOR_LIST',
	USER_ACTOR_ADD = 'ROLE_USER_ACTOR_ADD',
	USER_ACTOR_EDIT = 'ROLE_USER_ACTOR_EDIT',
	USER_ACTOR_DELETE = 'ROLE_USER_ACTOR_DELETE',
	IDEL_PATIENT_LIST = 'ROLE_IDEL_PATIENT_LIST',
	IDEL_PATIENT_ADD = 'ROLE_IDEL_PATIENT_ADD',
	IDEL_PATIENT_DELETE = 'ROLE_IDEL_PATIENT_DELETE',
	IDEL_ACTOR_LIST = 'ROLE_IDEL_ACTOR_LIST',
	IDEL_ACTOR_ADD = 'ROLE_IDEL_ACTOR_ADD',
	IDEL_ACTOR_DELETE = 'ROLE_IDEL_ACTOR_DELETE',
	IDEL_PATIENT_LIST_VALIDATOR = 'ROLE_IDEL_PATIENT_LIST_VALIDATOR',
	SURVEY_CAMPAIGN_VIEW = 'ROLE_SURVEY_CAMPAIGN_VIEW',
	SURVEY_CAMPAIGN_EDIT = 'ROLE_SURVEY_CAMPAIGN_EDIT',
	PCR_IMPORTER_LIST = 'ROLE_IMPORTER_PCR_LIST',
	PCR_IMPORTER_DELETE = 'ROLE_IMPORTER_PCR_DELETE',
	PCR_IMPORTER_DOWNLOAD = 'ROLE_IMPORTER_PCR_DOWNLOAD',
	PCR_IMPORTER_ADD = 'ROLE_IMPORTER_PCR_ADD',
	PCR_IMPORTER_VIEW = 'ROLE_IMPORTER_PCR_VIEW',
	UNDUE_LIST = 'ROLE_UNDUE_LIST',
	UNDUE_ADD = 'ROLE_UNDUE_ADD',
	CONTROL_IMPORTER_LIST = 'ROLE_IMPORTER_CONTROL_LIST',
	CONTROL_IMPORTER_DELETE = 'ROLE_IMPORTER_CONTROL_DELETE',
	CONTROL_IMPORTER_ADD = 'ROLE_IMPORTER_CONTROL_ADD',
	CONTROL_IMPORTER_VIEW = 'ROLE_IMPORTER_CONTROL_VIEW',
	CONTROL_IMPORTER_DOWNLOAD = 'ROLE_IMPORTER_CONTROL_DOWNLOAD',
}
